import axios from 'axios'
import { track } from './tracking'

document.querySelectorAll('[data-load-more]').forEach((loader) => {
  const holder = loader.querySelector('[data-load-more-holder]')
  const triggers = loader.querySelectorAll('[data-load-more-trigger]')

  if (!holder) return

  const request = {
    pageSize: loader.getAttribute('data-load-more-size'),
    postType: loader.getAttribute('data-load-more-type'),
  }

  // Alles, was der Besucher schon sieht: die Highlights aus dem Markup plus
  // jeder Teaser, der bereits in der Liste steht. Diese Liste wächst mit und
  // ist das Einzige, was Duplikate zuverlässig verhindert — auf die
  // Reihenfolge ist kein Verlass: RAND(seed) mischt komplett neu, sobald sich
  // die Treffermenge ändert (neues Projekt, neue Übersetzung), und Seite 1
  // kommt aus dem Seiten-Cache, die Nachladungen aus dem Cache der REST-Route.
  const seen = new Set(
    (loader.getAttribute('data-load-more-exclude') || '').split(',').filter(Boolean)
  )

  const collect = (scope) => {
    scope.querySelectorAll('[data-load-more-id]').forEach((elm) => seen.add(elm.dataset.loadMoreId))
  }

  // Lässt sich jede Kachel benennen? Direkt nach einem Deploy kann noch
  // gecachtes Markup ohne data-load-more-id dastehen. Dann ist unbekannt, was
  // schon geladen ist, und es bleibt beim Blättern über die Seitenzahl wie
  // bisher — sonst käme die erste Ladung sofort ein zweites Mal.
  const trackable =
    holder.children.length > 0 &&
    holder.querySelectorAll('[data-load-more-id]').length >= holder.children.length

  if (trackable) collect(holder)

  // Derselbe Seed wie beim Rendern der ersten Ladung, damit die Nachladungen
  // im selben Zufall weiterlaufen.
  const seed = loader.getAttribute('data-load-more-seed')

  if (seed) request.seed = seed

  // Die nachgeladenen Kacheln tragen dieselben Klassen wie die erste.
  const itemClass = holder.firstElementChild?.className ?? ''

  // get category from query string:
  const urlParams = new URLSearchParams(window.location.search)
  request.category = urlParams.get('kategorie')

  let page = 1
  let running = false

  const loadMore = async () => {
    // Zwei schnelle Klicks schickten sonst zweimal dieselbe exclude-Liste los
    // — und damit zweimal dieselben Projekte.
    if (running) return

    running = true
    triggers.forEach((elm) => elm.setAttribute('disabled', 'disabled'))

    try {
      // Mit vollständiger Ausschlussliste ist immer die erste Seite gemeint:
      // ein Offset würde genau die Treffer noch einmal überspringen, die schon
      // ausgeschlossen sind.
      const response = await axios.get(window.php_vars.restUrl + 'glunz/v1/loadmore', {
        params: {
          ...request,
          page: trackable ? 1 : page + 1,
          exclude: [...seen].join(','),
        },
      })

      page++
      track('load_more', { page_number: page, post_type: request.postType })

      response.data.posts.forEach((post) => {
        const parent = document.createElement('div')

        parent.className = itemClass
        parent.innerHTML = post

        if (trackable) collect(parent)
        holder.appendChild(parent)
      })

      if (response.data.isLastPage) {
        triggers.forEach((elm) => elm.classList.add('hidden'))
      }
    } finally {
      running = false
      triggers.forEach((elm) => elm.removeAttribute('disabled'))
    }
  }

  triggers.forEach((elm) => elm.addEventListener('click', () => loadMore()))
})
